import React, { useState } from "react";

import { CloseOutlined } from "@material-ui/icons";
import { Modal } from "react-bootstrap";
import ReactPlayer from "react-player";

import Carousel from "./Carousel";
import styles from "./ExtraSongsComponent.module.css";

const ExtraSongsComponent = ({ data, cmsData }) => {
  const [showModal, setShowModal] = useState(false);
  const [video, setVideo] = useState({});

  const handleVideoPlay = (videoData) => {
    setVideo(videoData);
    setShowModal(true);
  };

  return (
    <section className={styles.extra_songs_container}>
      <div
        className={`d-flex container-fluid flex-column justify-content-start align-items-center ${styles.extra_songs}`}
      >
        <h2 className={styles.extra_songs_slider_title}>
          {cmsData?.extra_songs_heading !== undefined
            ? cmsData?.extra_songs_heading
            : "Extra Songs"}
        </h2>
        <div className={`col ${styles.extra_songs_slider}`}>
          {data && (
            <Carousel
              items={[...data, ...data]}
              active={0}
              onPlay={handleVideoPlay}
            />
          )}
        </div>
      </div>
      <Modal
        centered
        show={showModal}
        dialogClassName={styles.extra_songs_video_modal}
        contentClassName={styles.extra_songs_video_modal_container}
        onHide={() => setShowModal(false)}
      >
        <Modal.Body>
          <CloseOutlined onClick={() => setShowModal(false)} />
          <ReactPlayer url={video.url} width="100%" controls playing />
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default ExtraSongsComponent;
